import React from "react";

const NotFound = () => {
    return <div>
        Page non trouvée
    </div>
}

export default NotFound;